"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _OTCKJ4OKcjs = require('./OTCKJ4OK.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/tooltip/tooltip-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_OTCKJ4OKcjs.HovercardContextProvider],
  [_OTCKJ4OKcjs.HovercardScopedContextProvider]
);
var useTooltipContext = ctx.useContext;
var useTooltipScopedContext = ctx.useScopedContext;
var useTooltipProviderContext = ctx.useProviderContext;
var TooltipContextProvider = ctx.ContextProvider;
var TooltipScopedContextProvider = ctx.ScopedContextProvider;







exports.useTooltipContext = useTooltipContext; exports.useTooltipScopedContext = useTooltipScopedContext; exports.useTooltipProviderContext = useTooltipProviderContext; exports.TooltipContextProvider = TooltipContextProvider; exports.TooltipScopedContextProvider = TooltipScopedContextProvider;
